import { RolodexEntryJson } from 'types/rolodex/rolodexEntries'
import { parseArray, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

export interface NavyProductionDashboardWidget {
  id: string
  title: string
  type:
    | 'pie'
    | 'bar'
    | 'stacked_bar'
    | 'timeline'
    | 'line'
    | 'table'
    | 'filter'
    | 'graph'
    | 'kpi'
  query?: string
  filterType?: 'select' | 'date'
  parameterName?: string
  defaultValue?: string
  customQuery?: string
  valueKeys?: string[]
  categoryKey?: string
  width?: number
  height?: number
  segment?: string
  nodeSizeProp?: string
  edgeLengthProp?: string
  defaultLabelProp?: string
  kpiUnit?: string
  kpiSubtitle?: string
  showLegend?: boolean
}

export interface NavyProductionDashboardPage {
  id: string
  title: string
  widgets: NavyProductionDashboardWidget[]
}

interface NavyProductionDashboardConfigTags {
  organization: string
  site: string
}

/**
 * An entry that represents a Navy Production Dashboard configuration
 */
export class GeckoNavyProductionDashboardConfig extends GeckoEntryBase<
  {
    pages: NavyProductionDashboardPage[]
    last_file_upload?: string
  },
  NavyProductionDashboardConfigTags
> {
  private constructor(json: RolodexEntryJson) {
    const pages = parseArray<NavyProductionDashboardPage>(json.data.pages) ?? []

    super(
      json,
      {
        pages,
        last_file_upload: parseString(json.data.last_file_upload),
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
      },
      {}
    )
  }

  /**
   * Factory method to create a GeckoNavyProductionDashboardConfig from raw JSON
   * @param json The raw JSON to create an instance from
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoNavyProductionDashboardConfig(json)
  }
}
